import req from "@/axios/index.js";

// 登录
export function getDoctorToken(params) {
  return req("post", "pharmacist/auth/token", params);
}
// 获取订单列表
export function getOrderList(params) {
  return req("get", "pharmacist/recipe/list", params);
}
// 药品字典
export function addDictMap(params) {
  return req("get", "case/getSpecs", params);
}
// 获取药师信息
export const getPharmcistById = function (params) {
  return req('get', 'pharmacist/info', params)
};
// 修改药师个人信息
export const savePharmcistById = function (params) {
  return req('post', 'pharmacist/edit/info/base', params)
};
// export function getDoctorToken(params) {
//   return req("post", "auth/pharmacist/token", params);
// }
//验证码登录接口
export const useCaptchaLogin = (params) =>
  req("get", "/pharmacist/information/smsLogin", params);
// 发送验证码接口
export const getCaptcha = function(params) {
  return req("post", "pharmacist/logoff/code", params);
};

//图形验证码接口
export const getPharmacistCaptcha = function (params) {
  return req('get', '/pharmacist/auth/captcha', params)
};

// 注册接口
export const publicsReg = function(params) {
  return req("get", "pharmacist/information/reg", params);
};

// 首页药师信息
export const getDoctorInfo = function(params) {
  return req("get", "pharmacist/info", params);
};

// 药师修改
export const doctorEdit = function(params) {
  return req("put", "pharmacist/information/edit", params);
};

// 首页今日快报、认证
export const getIndexForm = function(params) {
  return req("get", "pharmacist/information/express", params);
};

//处方统计
export const prescriptionTotal = function(params) {
  return req("get", "pharmacist/prescription/amount", params);
};

//处方列表
export const getPrescription = function(params) {
  return req("get", "pharmacist/prescription/list", params);
};

//处方详情
export const prescriptionDetail = function(params) {
  return req("get", "pharmacist/prescription/queryById", params);
};

//我的--首页诊断趋势图
export const getIndexMy = function(params) {
  return req("get", "pharmacist/prescription/trend", params);
};

//地区三级
export const getCityList = function(params) {
  return req("get", "system/area/list", params);
};

// 获取所属医院
export const getHospital = function(params) {
  return req("get", "system/hospital/list", params);
};

// 获取所属科室
export const getDepartment = function(params) {
  return req("get", "system/department/list", params);
};

//自定义
export const getHospitalList = function(params) {
  return req("get", "/pharmacist/department/hospitalList", params);
};

// 消息接口
// export const getMessageList = function(params) {
//   return req("get", "pharmacist/annountCement/list", params);
// };

//药师职称（配置） --获取字典分类
export const getSystem = function(params) {
  return req("get", `/pharmacist/dict/dictMap`, params);
};

//底部关于我们
export const agreemenInfo = function(params) {
  return req("get", "pharmacist/information/aboutUs", params);
};

// 消息已读接口
export const messageUpdate = function(params) {
  return req("get", "pharmacist/annountCement/editReadStatus", params);
};

// 消息全部已读
export const messageAllRead = function(params) {
  return req("get", "pharmacist/annountCement/readAll", params);
};

// 修改密码
export const updatePassword = function(params) {
  return req("post", "pharmacist/edit/pwd", params);
};

// 忘记密码接口
export const forgetPassword = function(params) {
  return req("get", "pharmacist/information/updatePassword", params);
};

//注销账户
export const delInfo = function(params) {
  return req("get", "pharmacist/logoff", params);
};

// 获取协议
export const getAgreement = function(params) {
  return req("get", "pharmacist/agreement/list", params);
};

// 设置更换手机号码
export const changMobile = function(params) {
  return req("get", "pharmacist/edit/mobile", params);
};

// 设置电子签名
export const setSign = function(params) {
  return req("get", "pharmacist/information/setSign", params);
};

// 在线诊疗监管数据上传接口
export const upWebTherapySuperviseInfo = function(params) {
  return req("get", "sys/hisPrescription/upWebTherapySuperviseInfo", params);
};

// 电子处方上传
export const prescriptionUpload = function(params) {
  return req("get", "sys/hisPrescription/prescriptionUpload", params);
};

// 处方审核(初审)
export const prescriptionReview = function(params) {
  return req("post", "pharmacist/recipe/check", params);
};

// 处方审核(复审)
export const prescriptionRecheck = function(params) {
  return req("post", "pharmacist/recipe/recheck", params);
};

// 生成报告
export const prescriptionPdf = function(params) {
  return req("post", "/pharmacist/recipe/generate/pdf?recipeId="+params.recipeId, params);
};

// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓PHP↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓

//首页--折线统计图-诊断趋势图--抛弃
export const getIndexTotal = function(params) {
  return req("get", "pharmacist/prescription/trend", params);
};

// 我的钱包统计接口
export const getWallet = function(params) {
  return req("get", "pc/wallet/getDetail", params);
};

// 我的钱包收入列表
export const getWalletList = function(params) {
  return req("get", "pc/income/index", params);
};

// 我的钱包申请提现
export const addCashout = function(params) {
  return req("post", "pc/cashout/add", params);
};

// 获取提现日志
export const getCashout = function(params) {
  return req("get", "pc/cashout/index", params);
};

// 首页我的患者列表
export const getSickList = function(params) {
  return req("get", "pc/sick/index", params);
};

// 首页我的预约列表
// export const getOrderList = function(params) {
//   return req("get", "pc/order/index", params);
// };

//圖片收藏
export const filmAdd = function(params) {
  return req("post", "pc/readfilm/add", params);
};
//药房添加
export const prescriptionAdd = function(params) {
  return req("post", "pc/prescription/add", params);
};
//值班信息
export const dutyInfo = function(params) {
  return req("get", "pc/doctor/duty", params);
};

//报告生成
export const setReport = function(params) {
  return req("get", "pc/doctor/report", params);
};

//报告生成  医生诊断生成报告
export const setCaseReport = function(params) {
  return req("get", "pc/Prescription/preview", params);
};
//报告生成  医生处方生成报告
export const setPrecriptionReport = function(params) {
  return req("get", "pc/Prescription/casesPreview", params);
};
//处方远程搜索
export const drugSearch = function(params) {
  return req("get", "pc/drug/index", params);
};
//患者信息
export const patientsInfo = function(params) {
  return req("get", "pc/Prescription/get_sick_info", params);
};

//报告列表
export const reportList = function(params) {
  return req("get", "pc/report/index", params);
};
//预约确认拒绝
export const appointHande = function(params) {
  return req("get", "pc/order/setStatus", params);
};
//阅片列表
export const readfilmList = function(params) {
  return req("get", "pc/readfilm/index", params);
};

//处方统计
export const casesDetail = function(params) {
  return req("get", "pc/cases/detail", params);
};

//诊断结果（远程搜索）
export const diagnose_result_search = function(params) {
  return req("get", "pc/diagnose_result/index", params);
};
//医嘱（远程搜索）
export const doctor_advice_search = function(params) {
  return req("get", "pc/doctor_advice/index", params);
};
export const readfilmPicList = function(params) {
  return req("get", "pc/readfilm/getReadFilm", params);
};
export const reportAdd = function(params) {
  return req("post", "pc/report/add", params);
};
export const eyeCase = function(params) {
  return req("get", "pc/eye_case/index", params);
};

//诊断结束
export const ordersClose = function(params) {
  return req("get", "pc/orders/close", params);
};

//签名
// export const prescription = function (params) {
//   return req('get', '/pharmacist/prescription/sign', params)
// }

//获取疾病列表
export const disease_code = function(params) {
  return req("get", "pc/disease_code/index", params);
};

//处方单信息
export const prescriptionReport = function(params) {
  return req("get", "pc/prescription/prescriptionReport", params);
};
